import { defineStore } from 'pinia'
let gameTabs = ["特码","两面","波色","特肖","头尾数","正码","正码1-6","平特一肖","尾数","自选不中","龙虎斗","尾数连"]
let newList = []
for (let index = 0; index < gameTabs.length; index++) {
  const element = gameTabs[index];
  newList.push({
    id:index,
    name:element,
  })
}
gameTabs = newList

export const useCommonStore = defineStore('common', {
  state: () => ({
    gamelist:{},
    gameTabs:newList,
    // 控制 keep-alive 缓存的组件列表
    cachedComponents: ['RoomView28', 'TrendView28', 'RuleView28']
  }),
  getters: {

  },
  actions: {
    // 从缓存中移除指定组件
    removeCachedComponent(componentName) {
      const index = this.cachedComponents.indexOf(componentName)
      if (index > -1) {
        this.cachedComponents.splice(index, 1)
      }
    },
    // 添加组件到缓存
    addCachedComponent(componentName) {
      if (!this.cachedComponents.includes(componentName)) {
        this.cachedComponents.push(componentName)
      }
    }
  }
})

